export var PAYMENT_CMDS = {
    COMMON: {
        DELETE: 'mobile_delete',
        GET: 'get_account'
    },
    TYPE_E: {
        START: 'mobile_create_hpp_start',
        FINISH: 'mobile_create_hpp_finish'
    },
    TYPE_CC: {
        START: 'mobile_create_token_account'
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/common/api-cmds/paymentCmds.ts
// module id = null
// module chunks = 